<!-- begin:: Footer -->
<div class="kt-footer kt-footer--extended kt-grid__item" id="kt_footer"
	[ngStyle]="{'background-image': getPageBackground()}">
	<div class="kt-footer__bottom">
		<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
			<div class="kt-footer__wrapper">
				<div class="kt-footer__logo">
					<a class="kt-header__brand-logo" routerLink="/">
						<img alt="Logo" [src]="footerLogo" class="kt-header__brand-logo-sticky">
					</a>
					<div class="kt-footer__copyright">
						{{today | date:'yyyy'}}&nbsp;©&nbsp;
						PricewaterhouseCoopers International
					</div>
				</div>
				<div class="kt-footer__menu">
					Versión {{version | async}}		
				</div>
			</div>
		</div>
	</div>
</div>
<!-- end:: Footer -->
